import Arrows from '../../../../assets/images/shopping/arrows';
import './LogisticServiceSpaceCard.scss';

const LogisticServiceSpaceCard = ({ spaceName }: { spaceName: string }) => {
  return (
    <div className="logisticServiceSpaceCard">
      <div className="absoluteContainer">
        <div className="iconSpace">
          <Arrows className="scaleIcon" />
        </div>
        <div className="spaceName">{spaceName}</div>
      </div>
    </div>
  );
};

export default LogisticServiceSpaceCard;
